/** @velyn-custom BEGIN — vely-collection-variant-finder.js */
(function () {
  const COLLAPSED_HEIGHT_DESKTOP = 65;
  const COLLAPSED_HEIGHT_MOBILE = 75;
  const MOBILE_MQ = window.matchMedia("(max-width: 767.98px)");
  const REDUCED_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)");

  function getCollapsedHeight() {
    return MOBILE_MQ.matches ? COLLAPSED_HEIGHT_MOBILE : COLLAPSED_HEIGHT_DESKTOP;
  }

  function clearHeightListener(wrap) {
    if (wrap._vcvfTransitionEnd) {
      wrap.removeEventListener("transitionend", wrap._vcvfTransitionEnd);
      wrap._vcvfTransitionEnd = null;
    }
  }

  function lockScrollHeight(wrap) {
    const height = wrap.scrollHeight;
    wrap.style.maxHeight = `${height}px`;
    return height;
  }

  function setExpanded(wrap, button, labelEl, labelLess) {
    clearHeightListener(wrap);

    const collapsed = getCollapsedHeight();
    wrap.removeAttribute("data-collapsed");
    button.setAttribute("aria-expanded", "true");
    if (labelEl) labelEl.textContent = labelLess;

    if (REDUCED_MOTION.matches) {
      wrap.style.maxHeight = "none";
      return;
    }

    wrap.style.maxHeight = `${collapsed}px`;
    wrap.offsetHeight;
    wrap.style.maxHeight = `${wrap.scrollHeight}px`;

    wrap._vcvfTransitionEnd = (event) => {
      if (event.target !== wrap || event.propertyName !== "max-height") return;
      clearHeightListener(wrap);
      wrap.style.maxHeight = "none";
    };
    wrap.addEventListener("transitionend", wrap._vcvfTransitionEnd);
  }

  function setCollapsed(wrap, button, labelEl, labelMore, animate) {
    clearHeightListener(wrap);

    button.setAttribute("aria-expanded", "false");
    if (labelEl) labelEl.textContent = labelMore;

    if (!animate || REDUCED_MOTION.matches) {
      wrap.setAttribute("data-collapsed", "");
      wrap.style.maxHeight = `${getCollapsedHeight()}px`;
      return;
    }

    // Lock current full height first (handles max-height: none after expand).
    if (!wrap.style.maxHeight || wrap.style.maxHeight === "none") {
      lockScrollHeight(wrap);
      wrap.offsetHeight;
    }

    wrap.setAttribute("data-collapsed", "");
    wrap.style.maxHeight = `${getCollapsedHeight()}px`;
  }

  function updateToggleVisibility(wrap, button) {
    const wasCollapsed = wrap.hasAttribute("data-collapsed");
    const previousMax = wrap.style.maxHeight;

    wrap.style.maxHeight = "none";
    const full = wrap.scrollHeight;
    const collapsed = getCollapsedHeight();

    if (wasCollapsed) {
      wrap.style.maxHeight = previousMax || `${collapsed}px`;
    } else {
      wrap.style.maxHeight = previousMax || "none";
    }

    if (full <= collapsed + 4) {
      button.hidden = true;
      wrap.removeAttribute("data-collapsed");
      wrap.style.maxHeight = "none";
      button.setAttribute("aria-expanded", "true");
    } else {
      button.hidden = false;
    }
  }

  function bindToggle(root) {
    const wrap = root.querySelector(".vcvf__description-wrap");
    const button = root.querySelector(".vcvf__toggle");
    if (!wrap || !button || button.dataset.bound === "true") return;

    button.dataset.bound = "true";
    const labelMore = button.dataset.labelMore || "Mehr lesen";
    const labelLess = button.dataset.labelLess || "Lese weniger";
    const labelEl = button.querySelector(".vcvf__toggle-label");

    setCollapsed(wrap, button, labelEl, labelMore, false);
    updateToggleVisibility(wrap, button);

    button.addEventListener("click", (event) => {
      event.preventDefault();
      const isCollapsed = wrap.hasAttribute("data-collapsed");
      if (isCollapsed) {
        setExpanded(wrap, button, labelEl, labelLess);
      } else {
        setCollapsed(wrap, button, labelEl, labelMore, true);
      }
    });

    let resizeTimer;
    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const isCollapsed = wrap.hasAttribute("data-collapsed");
        if (isCollapsed) {
          setCollapsed(wrap, button, labelEl, labelMore, false);
        } else if (button.getAttribute("aria-expanded") === "true") {
          wrap.style.maxHeight = "none";
        }
        updateToggleVisibility(wrap, button);
      }, 150);
    };

    window.addEventListener("resize", onResize, { passive: true });
    wrap._vcvfResizeHandler = onResize;
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll(".section-vely-collection-variant-finder")
      .forEach((root) => bindToggle(root));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    event.target
      ?.querySelectorAll?.(".vcvf__description-wrap")
      .forEach((wrap) => {
        clearHeightListener(wrap);
        if (wrap._vcvfResizeHandler) {
          window.removeEventListener("resize", wrap._vcvfResizeHandler);
          wrap._vcvfResizeHandler = null;
        }
      });
  });
})();
/** @velyn-custom END — vely-collection-variant-finder.js */
